// TODO:
// 1-consider responsiveness when user changes font size in browser settings.

import { useTheme } from "design-system/themeContext";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageName } from "store/slices/routeName/routeNameSlice";

import { useGetAllBuildings } from "../api/hooks/allHooks";
import { CardsContainer, FilterContainer } from "../components/AssetOverview";
import { extractCertifications, extractLocations, getEnergyClassItem } from "../functions/AssetOverview";
import { eventNames, trackGAEvent } from "../functions/googleAnalytics";
import { filterDataBySearchTerm, filterDataBySinlgeValueFilter, filterDataByYear } from "../utils/dataManipulation";

const nullAlternative = "Pending";
export const AssetOverview = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    dispatch(setCurrentPageName("asset overview"));
    trackGAEvent(eventNames.AO_VIEW);
  }, []);

  const { filters, searchTerm } = useSelector((store) => store.allBuildings);
  const { user } = useSelector((store) => store.user);

  const { data, isLoading } = useGetAllBuildings(user?.user_id);
  let allBuildings = data?.map((building) => {
    if (building.energy_label) return building;
    else {
      const energyClassItem = getEnergyClassItem({ energyConsumption: building.energy_consumption });
      const energy_label = energyClassItem?.rating;
      return { ...building, energy_label };
    }
  });
  allBuildings = allBuildings || [];

  const dataLocations = extractLocations(allBuildings, nullAlternative);
  const dataCertificates = extractCertifications(allBuildings, nullAlternative);

  const filterCards = () => {
    let filteredBuildings;
    filteredBuildings = filterDataBySearchTerm(allBuildings, searchTerm, "name");
    for (const filterName in filters) {
      const filterValues = filters[filterName].values;
      const lookUpField = filters[filterName].lookUpField;
      const nestedLookUpField = filters[filterName].nestedLookUpField;
      if (filterName === "year")
        filteredBuildings = filterDataByYear(
          filteredBuildings,
          filterValues,
          filters[filterName].options,
          lookUpField,
          nullAlternative
        );
      else {
        filteredBuildings = filterDataBySinlgeValueFilter(
          filteredBuildings,
          filterValues,
          lookUpField,
          nestedLookUpField,
          nullAlternative
        );
      }
    }
    return filteredBuildings;
  };
  const filteredBuildings = filterCards();

  return (
    <div>
      <Helmet>
        <title>Asset overview | {theme.clientDisplayName}</title>
      </Helmet>
      <h1 className="sentence-case font-ds-display-lg text-lds-foreground-primary">{t("AssetOverview.title")}</h1>
      <FilterContainer
        certificatesOptions={dataCertificates}
        locationsOptions={dataLocations}
        noOfCards={filteredBuildings?.length}
      />
      <CardsContainer buildings={filteredBuildings} className="mt-3" isLoading={isLoading} />
    </div>
  );
};
